module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-number-container"
  }, [_c('input', {
    staticClass: "form-control input-number__input",
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "type": "number",
      "name": "",
      "data-container": "body",
      "disabled": ""
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-toggle__container"
  }, [_c('button', {
    staticClass: "btn btn-toggle__inc",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.increment
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-toggle__dec",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.decrement
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0259dfad","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/BasketInput.vue
// module id = 768
// module chunks = 0